import * as yup from 'yup';

export const commonCompFspValidation: { [x: string]: any; } = {
    shipmentType: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
    chargeType: yup.string().required("Missing."),
    fspUOM: yup.string().required("Missing."),
    firstTierFSP: yup.number().required("Missing."),
    secondTierFSP: yup.number().required("Missing."),
    fspCountingFromVal: yup.string().required("Missing."),
    fspCountingToVal: yup.string().required("Missing."),
    fspCountingDirection: yup.string().required("Missing."),
    fspCalculateMethod: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
    splitFirstDays: yup.number()
        .when(['chargeType', 'subChargeType'], {
            is: (chargeType: string | null | undefined, subChargeType: string | null | undefined) =>
                chargeType === 'RFH' && subChargeType === 'T1',
            then: (schema) => schema.required('Missing.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    splitFirstDaysTo: yup.string()
        .when(['chargeType', 'subChargeType'], {
            is: (chargeType: string | null | undefined, subChargeType: string | null | undefined) =>
                chargeType === 'RFH' && subChargeType === 'T1',
            then: (schema1) => schema1.required('Missing.'),
            otherwise: (schema1) => schema1.notRequired(),
        }),
    splitRemainDaysTo: yup.string()
        .when(['chargeType', 'subChargeType'], {
            is: (chargeType: string | null | undefined, subChargeType: string | null | undefined) =>
                chargeType === 'RFH' && subChargeType === 'T1',
            then: (schema2) => schema2.required('Missing.'),
            otherwise: (schema2) => schema2.notRequired(),
        }),
};

export const compFspValidation: { [x: string]: any; } = {
    ...commonCompFspValidation,
};

export const commonCompFspValidationSchema = yup.object().shape(compFspValidation);
